
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop/product/[productSlug]",
      function () {
        return require("private-next-pages/shop/product/[productSlug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shop/product/[productSlug]"])
      });
    }
  